import React from 'react';

import {
    GlobeIcon,
    HiddenIcon,
    PrivacyDesc,
    PrivacyHeading,
    PrivacyInner,
    PrivacyItem,
    PrivacyLabel,
    PrivacyWrapper,
    Radio,
} from './styles';

interface Props {
    isPrivate?: boolean;
    handleRadioChange(val: boolean): void;
    heading: string;
    publicDescription: string;
    privateDescription: string;
}

export const PrivacyOptions = ({
    isPrivate,
    handleRadioChange,
    heading,
    publicDescription,
    privateDescription,
}: Props) => {
    return (
        <PrivacyWrapper>
            <PrivacyHeading>{heading}</PrivacyHeading>
            <PrivacyInner>
                <PrivacyItem onClick={() => handleRadioChange(false)}>
                    <PrivacyLabel>
                        <GlobeIcon /> Public
                    </PrivacyLabel>
                    <PrivacyDesc>{publicDescription}</PrivacyDesc>
                    <Radio $active={isPrivate === false} className="radio">
                        <div />
                    </Radio>
                </PrivacyItem>
                <PrivacyItem onClick={() => handleRadioChange(true)}>
                    <PrivacyLabel>
                        <HiddenIcon /> Private
                    </PrivacyLabel>
                    <PrivacyDesc>{privateDescription}</PrivacyDesc>
                    <Radio $active={isPrivate === true} className="radio">
                        <div />
                    </Radio>
                </PrivacyItem>
            </PrivacyInner>
        </PrivacyWrapper>
    );
};
